import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Logout.css';
import logo from '../assets/logo.png'; // Adjust the path to your logo file
import { logout } from '../redux/authSlice';

const Logout = () => {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    setError('');
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    navigate('/');
  };

  return (
    <div className="logout-container">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Logout Complete</h1>
      {error && <div className="error-message">{error}</div>}
      <form className="logout-form" onSubmit={handleSubmit}>
        <button type="submit">Return To Login Screen</button>
      </form>
    </div>
  );
};


export default Logout;

